<template>
  <span
    v-show="ratingIsVisible"
    :data-rating-count="`(${rateCount.toLocaleString()})`"
    class="rating-bubble"
  >
    <span class="rating-value">{{ ratingFormatted }}</span>
  </span>
</template>

<script lang="ts">
import {
  Component,
  Prop,
  Vue,
  Setup,
  toNative,
} from '~/utility/pu-class-decorator'

@Component({})
class PuRatingBubble extends Vue {
  @Setup(() => {
    const { t } = useI18n()
    return t('No rating')
  })
  defaultValue: string

  @Prop({ default: 0 })
  rating!: number

  @Prop({ default: 0 })
  rateCount!: number

  @Prop({ default: false })
  forceVisibility!: boolean

  get ratingIsVisible() {
    return this.rateCount >= 3 || this.forceVisibility === true
  }

  get ratingFormatted() {
    const rating = this.rating || 0
    // rating.toFixed returns a string - for example '10.0'
    // parseFloat will convert that string into a number dropping any trailing zeros
    return parseFloat(rating.toFixed(1))
  }
}

export default toNative(PuRatingBubble)
</script>

<style scoped>
.rating-bubble {
  align-items: center;
  background: #3a82a6;
  border-radius: 100%;
  color: #fff;
  display: inline-flex;
  font-size: 0.9em;
  justify-content: center;
  line-height: 1;
  min-height: 1.6em;
  min-width: 2.2em;
  position: relative;
  user-select: none;
  z-index: 1;
}

.rating-value {
  color: white;
  font-weight: bold;
  letter-spacing: -0.035em;
}

.rating-bubble:after {
  background: url('~/assets/images/ratings-bubble-tail.svg') left top no-repeat;
  bottom: -0.1em;
  content: '';
  display: block;
  height: 0.75em;
  left: -0.15em;
  position: absolute;
  width: 1.3125em;
  z-index: -1;
}

.rating-bubble:before {
  bottom: -1.25em;
  color: var(--colour-text-default);
  content: attr(data-rating-count);
  font-size: var(--tiny);
  left: auto;
  position: absolute;
  right: auto;
  text-align: center;
  top: auto;
}

.rating-bubble.user-rating {
  background: #0a9c2a;
}

.rating-bubble.user-rating:after {
  background: url('~/assets/images/ratings-bubble-tail-alt.svg') left top
    no-repeat;
}

.rating-bubble.user-rating:before {
  content: '';
}
</style>
